import { VHCRecordLabourInput, VhcRecordLogService } from 'api/generated';
import { ApiMutationOptions, useMutationWithNotifications } from 'api/utils/useMutationWithNotifications';

export type UpdateCheckLabourInput = {
  logId: number;
  itemId: number;
  labourId: number;
  requestBody?: VHCRecordLabourInput;
};

export const useUpdateCheckLabourMutation = (
  options?: ApiMutationOptions<typeof VhcRecordLogService.putVhcRecordsItemsChecksLabours, UpdateCheckLabourInput>
) =>
  useMutationWithNotifications(
    ({ logId, itemId, labourId, requestBody }: UpdateCheckLabourInput) =>
      VhcRecordLogService.putVhcRecordsItemsChecksLabours(logId, itemId, labourId, requestBody),
    options
  );
